// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `[data-line-item-list] .line-item-drag-handle,
.line-item-drag-preview .line-item-drag-handle {
  display: inline-grid;
  flex: 0 0 24px;
  width: 24px;
  height: 32px;
  padding: 0;
  place-items: center;
  border: 0;
  border-radius: var(--radius-sm, 6px);
  background: transparent;
  color: var(--text-secondary);
  cursor: grab;
  touch-action: none;
  -webkit-user-select: none;
          user-select: none;
}

[data-line-item-list] .line-item-drag-handle:active {
  cursor: grabbing;
}
[data-line-item-list] .line-item-drag-handle:focus-visible {
  outline: 2px solid var(--interactive-default);
  outline-offset: 2px;
}
[data-line-item-list] .line-item-drag-handle:disabled {
  cursor: default;
  opacity: 0.4;
}

[data-line-item-list].line-item-list-is-reordering {
  cursor: grabbing;
  -webkit-user-select: none;
          user-select: none;
}

[data-line-item-list] [data-line-item-index] {
  position: relative;
  transform: translate3d(0, var(--line-item-row-shift-y, 0), 0);
  transition: transform 180ms cubic-bezier(0.2, 0, 0, 1), box-shadow 180ms ease,
    background-color 180ms ease, opacity 140ms ease;
}

[data-line-item-list] .line-item-is-dragging:not(.line-item-drag-preview) {
  overflow: visible !important;
  background: var(--interactive-soft, #e6f4f2);
  box-shadow: none;
  opacity: 0.2;
  outline: 2px dashed var(--interactive-default, #0f766e);
  outline-offset: -2px;
}

[data-line-item-list] .line-item-is-dragging .line-item-drag-handle,
.line-item-drag-preview .line-item-drag-handle {
  background: var(--interactive-soft, #e6f4f2);
  color: var(--interactive-default, #0f766e);
  cursor: grabbing;
}

[data-line-item-list] .line-item-is-dragging .line-item-drag-handle svg,
.line-item-drag-preview .line-item-drag-handle svg {
  animation: line-item-drag-handle-pulse 700ms ease-in-out infinite alternate;
}

[data-line-item-list] .line-item-drop-before {
  background: var(--interactive-soft, #e6f4f2);
  box-shadow: inset 0 3px 0 var(--interactive-default);
}

[data-line-item-list] .line-item-drop-after {
  background: var(--interactive-soft, #e6f4f2);
  box-shadow: inset 0 -3px 0 var(--interactive-default);
}

.line-item-drag-layer {
  position: fixed;
  z-index: 10000;
  inset: 0;
  display: block;
  width: 100vw;
  height: 100vh;
  min-height: 0;
  overflow: visible !important;
  background: transparent !important;
  pointer-events: none;
}

.line-item-drag-layer .line-item-drag-surface {
  display: contents;
}

.line-item-drag-layer .line-item-drag-preview {
  position: fixed !important;
  z-index: 1;
  box-sizing: border-box;
  margin: 0;
  padding-inline: var(--space-3, 12px);
  overflow: visible !important;
  border-radius: var(--radius-md, 10px);
  background: var(--surface-primary, #fff);
  box-shadow: 0 18px 36px rgba(14, 38, 36, 0.18),
    0 4px 10px rgba(14, 38, 36, 0.12);
  opacity: 0.98;
  outline: 2px solid var(--interactive-default, #0f766e);
  outline-offset: -2px;
  transform: translate3d(
      var(--line-item-drag-offset-x, 0),
      var(--line-item-drag-offset-y, 0),
      0
    )
    scale(1.012);
  transition: background-color 140ms ease, box-shadow 140ms ease,
    opacity 140ms ease, outline-color 140ms ease;
  will-change: transform;
  animation: line-item-drag-lift 160ms ease-out;
  pointer-events: none;
}

.line-item-drag-layer .line-item-drag-preview * {
  pointer-events: none !important;
}
.line-item-drag-layer.dark .line-item-drag-preview,
.line-item-drag-layer[data-theme="dark"] .line-item-drag-preview {
  background: var(--surface-elevated, #25282e);
  box-shadow: 0 18px 38px rgba(0, 0, 0, 0.48), 0 4px 12px rgba(0, 0, 0, 0.34);
}

@keyframes line-item-drag-lift {
  from {
    opacity: 0.72;
    filter: saturate(0.8);
  }
  to {
    opacity: 0.98;
    filter: saturate(1);
  }
}

@keyframes line-item-drag-handle-pulse {
  from {
    transform: scale(0.92);
  }
  to {
    transform: scale(1.08);
  }
}

@media (prefers-reduced-motion: reduce) {
  [data-line-item-list] [data-line-item-index],
  [data-line-item-list] .line-item-drag-handle svg,
  .line-item-drag-preview,
  .line-item-drag-preview .line-item-drag-handle svg {
    animation: none !important;
    transition: none !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/lineItemReorder.css"],"names":[],"mappings":"AAAA;;EAEE,oBAAoB;EACpB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,UAAU;EACV,mBAAmB;EACnB,SAAS;EACT,oCAAoC;EACpC,uBAAuB;EACvB,4BAA4B;EAC5B,YAAY;EACZ,kBAAkB;EAClB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,6CAA6C;EAC7C,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,6DAA6D;EAC7D;mDACiD;AACnD;;AAEA;EACE,4BAA4B;EAC5B,4CAA4C;EAC5C,gBAAgB;EAChB,YAAY;EACZ,uDAAuD;EACvD,oBAAoB;AACtB;;AAEA;;EAEE,4CAA4C;EAC5C,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;;EAEE,2EAA2E;AAC7E;;AAEA;EACE,4CAA4C;EAC5C,oDAAoD;AACtD;;AAEA;EACE,4CAA4C;EAC5C,qDAAqD;AACvD;;AAEA;EACE,eAAe;EACf,cAAc;EACd,QAAQ;EACR,cAAc;EACd,YAAY;EACZ,aAAa;EACb,aAAa;EACb,4BAA4B;EAC5B,kCAAkC;EAClC,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;EAC1B,UAAU;EACV,sBAAsB;EACtB,SAAS;EACT,oCAAoC;EACpC,4BAA4B;EAC5B,qCAAqC;EACrC,wCAAwC;EACxC;qCACmC;EACnC,aAAa;EACb,sDAAsD;EACtD,oBAAoB;EACpB;;;;;gBAKc;EACd;gDAC8C;EAC9C,sBAAsB;EACtB,6CAA6C;EAC7C,oBAAoB;AACtB;;AAEA;EACE,+BAA+B;AACjC;AACA;;EAEE,4CAA4C;EAC5C,2EAA2E;AAC7E;;AAEA;EACE;IACE,aAAa;IACb,qBAAqB;EACvB;EACA;IACE,aAAa;IACb,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;;;;IAIE,0BAA0B;IAC1B,2BAA2B;EAC7B;AACF","sourcesContent":["[data-line-item-list] .line-item-drag-handle,\n.line-item-drag-preview .line-item-drag-handle {\n  display: inline-grid;\n  flex: 0 0 24px;\n  width: 24px;\n  height: 32px;\n  padding: 0;\n  place-items: center;\n  border: 0;\n  border-radius: var(--radius-sm, 6px);\n  background: transparent;\n  color: var(--text-secondary);\n  cursor: grab;\n  touch-action: none;\n  user-select: none;\n}\n\n[data-line-item-list] .line-item-drag-handle:active {\n  cursor: grabbing;\n}\n[data-line-item-list] .line-item-drag-handle:focus-visible {\n  outline: 2px solid var(--interactive-default);\n  outline-offset: 2px;\n}\n[data-line-item-list] .line-item-drag-handle:disabled {\n  cursor: default;\n  opacity: 0.4;\n}\n\n[data-line-item-list].line-item-list-is-reordering {\n  cursor: grabbing;\n  user-select: none;\n}\n\n[data-line-item-list] [data-line-item-index] {\n  position: relative;\n  transform: translate3d(0, var(--line-item-row-shift-y, 0), 0);\n  transition: transform 180ms cubic-bezier(0.2, 0, 0, 1), box-shadow 180ms ease,\n    background-color 180ms ease, opacity 140ms ease;\n}\n\n[data-line-item-list] .line-item-is-dragging:not(.line-item-drag-preview) {\n  overflow: visible !important;\n  background: var(--interactive-soft, #e6f4f2);\n  box-shadow: none;\n  opacity: 0.2;\n  outline: 2px dashed var(--interactive-default, #0f766e);\n  outline-offset: -2px;\n}\n\n[data-line-item-list] .line-item-is-dragging .line-item-drag-handle,\n.line-item-drag-preview .line-item-drag-handle {\n  background: var(--interactive-soft, #e6f4f2);\n  color: var(--interactive-default, #0f766e);\n  cursor: grabbing;\n}\n\n[data-line-item-list] .line-item-is-dragging .line-item-drag-handle svg,\n.line-item-drag-preview .line-item-drag-handle svg {\n  animation: line-item-drag-handle-pulse 700ms ease-in-out infinite alternate;\n}\n\n[data-line-item-list] .line-item-drop-before {\n  background: var(--interactive-soft, #e6f4f2);\n  box-shadow: inset 0 3px 0 var(--interactive-default);\n}\n\n[data-line-item-list] .line-item-drop-after {\n  background: var(--interactive-soft, #e6f4f2);\n  box-shadow: inset 0 -3px 0 var(--interactive-default);\n}\n\n.line-item-drag-layer {\n  position: fixed;\n  z-index: 10000;\n  inset: 0;\n  display: block;\n  width: 100vw;\n  height: 100vh;\n  min-height: 0;\n  overflow: visible !important;\n  background: transparent !important;\n  pointer-events: none;\n}\n\n.line-item-drag-layer .line-item-drag-surface {\n  display: contents;\n}\n\n.line-item-drag-layer .line-item-drag-preview {\n  position: fixed !important;\n  z-index: 1;\n  box-sizing: border-box;\n  margin: 0;\n  padding-inline: var(--space-3, 12px);\n  overflow: visible !important;\n  border-radius: var(--radius-md, 10px);\n  background: var(--surface-primary, #fff);\n  box-shadow: 0 18px 36px rgba(14, 38, 36, 0.18),\n    0 4px 10px rgba(14, 38, 36, 0.12);\n  opacity: 0.98;\n  outline: 2px solid var(--interactive-default, #0f766e);\n  outline-offset: -2px;\n  transform: translate3d(\n      var(--line-item-drag-offset-x, 0),\n      var(--line-item-drag-offset-y, 0),\n      0\n    )\n    scale(1.012);\n  transition: background-color 140ms ease, box-shadow 140ms ease,\n    opacity 140ms ease, outline-color 140ms ease;\n  will-change: transform;\n  animation: line-item-drag-lift 160ms ease-out;\n  pointer-events: none;\n}\n\n.line-item-drag-layer .line-item-drag-preview * {\n  pointer-events: none !important;\n}\n.line-item-drag-layer.dark .line-item-drag-preview,\n.line-item-drag-layer[data-theme=\"dark\"] .line-item-drag-preview {\n  background: var(--surface-elevated, #25282e);\n  box-shadow: 0 18px 38px rgba(0, 0, 0, 0.48), 0 4px 12px rgba(0, 0, 0, 0.34);\n}\n\n@keyframes line-item-drag-lift {\n  from {\n    opacity: 0.72;\n    filter: saturate(0.8);\n  }\n  to {\n    opacity: 0.98;\n    filter: saturate(1);\n  }\n}\n\n@keyframes line-item-drag-handle-pulse {\n  from {\n    transform: scale(0.92);\n  }\n  to {\n    transform: scale(1.08);\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  [data-line-item-list] [data-line-item-index],\n  [data-line-item-list] .line-item-drag-handle svg,\n  .line-item-drag-preview,\n  .line-item-drag-preview .line-item-drag-handle svg {\n    animation: none !important;\n    transition: none !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
